<template>
  <div class="container">
    <div class="input">
      <a-select
        ref="select"
        allowClear
        v-model="data"
        mode="multiple"
        @change="handleChange"
        @select="handleSelect"
        placeholder="选择机器人"
        style="width:100%;"
      >
        <a-spin v-if="loading" slot="notFoundContent" size="small" />
        <a-select-option value="all" v-if="list.length > 0">全选</a-select-option>
        <a-select-option
          v-for="item in list"
          :key="item.id"
          :title="item | title"
        >{{item.id}}（{{item.nickname}}）</a-select-option>
      </a-select>
    </div>
    <div class="select">
      <a-select mode="multiple" allowClear labelInValue style="width: 100%;" @change="handleSelectGroup" placeholder="分组">
        <template v-for="(item,index) in groupDataSource">
          <a-select-option :key="index" :value="item.id">{{item.group_name}}</a-select-option>
        </template>
      </a-select>
    </div>
  </div>
</template>

<script>
import DeviceApi from '@/api/device'
import DeviceGroupApi from '@/api/device-group'
export default {
  data() {
    return {
      loading: false,
      list: [],
      data: [],
      groupDataSource: []
    }
  },
  model: {
    prop: 'value',
    event: 'returnBack'
  },
  props: {
    value: {
      type: Array
    }
  },
  watch: {
    data(newVal) {
      this.$emit('change', newVal)
      this.$emit('returnBack', newVal)
    },
    value(newVal) {
      this.data = newVal
    }
  },
  created() {
    this.getData()
    this.getGroupData()
  },
  filters: {
    title(obj) {
      return `${obj.id}（${obj.nickname}）`
    }
  },
  methods: {
    getData() {
      this.loading = true
      DeviceApi.getList({ pageSize: 2000 })
        .then(res => {
          this.list = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    getGroupData() {
      DeviceGroupApi.getList(
        Object.assign({
          pageSize: 200
        })
      ).then(res => {
        this.groupDataSource = res.data
      })
    },
    handleChange(value) {
      if (value.includes('all')) {
        this.allElection()
      }
    },
    handleSelect(value, option) {
      // console.log(value)
    },
    allElection() {
      const list = this.list
      let arr = []
      for (let i in list) {
        arr.push(list[i]['id']) //属性
      }
      this.data = arr
      this.$refs.select.blur()
    },
    handleSelectGroup(data) {
      const ids = data.map((item)=>{
        return item.key
      })
      const list = this.list.filter((item)=>{
        return ids.includes(item.group_id)
      })
      let arr = []
      for (let i in list) {
        arr.push(list[i]['id']) //属性
      }
      this.data = arr
      this.$refs.select.blur()
    },
    getCurrentSelectData() {
      const list = this.list.filter((item)=>{
        return this.data.includes(item.id)
      })
      return list
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: row;
  .input {
    flex: 1;
  }
  .select {
    padding-left: 10px;
    width: 120px;
    max-width: 120px;
  }
}
</style>
